import { useApolloClient } from "@apollo/react-hooks";
import { useHistory } from "react-router";
import { ZENDESK_URL_QUERY } from "utils/mutations";

export default () => {
  const client = useApolloClient();
  const { push } = useHistory();
  const openExternalSupport = () => {
    client
      .query({ query: ZENDESK_URL_QUERY, fetchPolicy: "network-only" })
      .then((results) => {
        const supportUrl = results?.data?.getZendesk?.ssoUrl;
        if (supportUrl) {
          window.location.assign(supportUrl);
        } else {
          push(`/support`);
        }
      })
      .catch(() => {
        push(`/support`);
      });
  };

  return {
    openExternalSupport,
  };
};
